import Styled from '@/components/TextIllustrationColumns.styled';
import { FC, ReactNode } from 'react';

type TextIllustrationColumns_Column = {
  id: string | number;
  heading?: string;
  content: ReactNode;
  illustration?: ReactNode;
};

export interface TextIllustrationColumnsProps {
  heading?: string;
  columns: TextIllustrationColumns_Column[];
  columnHeadingStyle: 'standard' | 'smallCaps';
  columnTextStyle: 'standard' | 'largeBold';
  columnIllustrationSize: 'standard' | 'large';
}

const TextIllustrationColumns: FC<TextIllustrationColumnsProps> = (props) => {
  const ColumnHeading = (() => {
    switch (props.columnHeadingStyle) {
      case 'smallCaps':
        return Styled.ColumnHeadingSmallCaps;
      case 'standard':
      default:
        return Styled.ColumnHeadingStandard;
    }
  })();

  const ColumnContent = (() => {
    switch (props.columnTextStyle) {
      case 'largeBold':
        return Styled.ColumnContentLargeBold;
      case 'standard':
      default:
        return Styled.ColumnContentStandard;
    }
  })();

  return (
    <section>
      {!!props.heading && <Styled.Heading>{props.heading}</Styled.Heading>}

      <Styled.Grid>
        {props.columns.map((column, index) => (
          <Styled.Column key={column.id} center={index === 0 && props.columns.length % 2 === 1}>
            <Styled.ColumnIllustration size={props.columnIllustrationSize}>
              {column.illustration}
            </Styled.ColumnIllustration>

            {!!column.heading && <ColumnHeading>{column.heading}</ColumnHeading>}

            <ColumnContent>{column.content}</ColumnContent>
          </Styled.Column>
        ))}
      </Styled.Grid>
    </section>
  );
};

export default TextIllustrationColumns;
